export default {
      id: "reefer-defrost-usage",
      viewBox: "0 0 38 37",
      url: __webpack_public_path__ + "img/icons.svg#reefer-defrost",
      toString: function () {
        return this.url;
      }
    }